import React, { useState, useEffect,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap, Sparkles, LogOut, ArrowRight, MessageSquare, Shield, Mic } from 'lucide-react';
import axios from 'axios';

export default function Indexs() {
  const navigate = useNavigate();
  const sessionId = localStorage.getItem('session_id');
  const [user, setUser] = useState('');
  
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user`, { withCredentials: true, });
        setUser(res.data || '');
      } catch {
        setUser(null);
      }
    };
    fetchUser();
  }, []);

  const handleSignOut = async () => {
    try {
      if (user){
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/logout`, { withCredentials: true, });
      setUser('');
      navigate('/');
      }
      else{
        navigate('/auth');
      }
    } catch (err) {
      console.error('Logout failed', err);
      navigate('/auth');
    }
  };

  const features = [
    {
      icon: <MessageSquare size={24} color="#fff" />,
      title: 'AI Content Generation',
      description: 'Create viral posts, videos scripts, and ads in seconds',
    },
    {
      icon: <Shield size={24} color="#fff" />,
      title: 'Lead Capture & CRM',
      description: 'Capture and manage leads from all your channels',
    },
    {
      icon: <Mic size={24} color="#fff" />,
      title: 'Review Management',
      description: 'Track customer reviews and boost your reputation',
    },
  ];

  return (
    <div style={S.page}>
      <div style={S.glow1} />
      <div style={S.glow2} />

      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes pulse { 0%,100% { opacity: 0.3; } 50% { opacity: 0.6; } }
        .feature-card:hover { border-color: rgba(255,255,255,0.2) !important; transform: translateY(-4px); }
        .cta-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(124,58,237,0.4); }
      `}</style>

      {/* Header */}
      <header style={S.header}>
        <div style={S.headerInner}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 20 }}>⚡</span>
            <span style={S.logoText}>Content</span>
            <span style={S.logoBeta}>BETA</span>
          </div>
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <button
              onClick={handleSignOut}
              style={S.signOutBtn}
            >
              <LogOut size={14} />
              {user ? 'Sign Out' : 'Sign In'}
            </button>
            <button
              onClick={() => navigate(user ? '/dashboard' : '/auth')}
              style={S.navBtn}
            >
              {user?.role === "premium" ? 'Open App →' : 'Get Started →'}
            </button>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section style={S.hero}>
        <div style={{ ...S.badge, animation: "fadeUp 0.4s ease both" }}>
          <Sparkles size={14} color="#C8A96E" />
          <span>Launch campaign and spend less on marketing</span>
        </div>

        <h1 style={{ ...S.heroTitle, animation: "fadeUp 0.5s ease both" }}>
          Viral Content<br />
          <em style={{ fontStyle: "italic", color: "#C8A96E" }}>Generated</em>
        </h1>

        <p style={{ ...S.heroSubtitle, animation: "fadeUp 0.6s ease both" }}>
          Launch Campaign —<br />
          
        </p>


        
        <button
          className="cta-btn"
          onClick={() =>
            navigate(user?.role === "premium" ? "/dashboard" : "/auth")
          }
          style={{ ...S.ctaBtn, animation: "fadeUp 0.8s ease both" }}
          >
          {user?.role === "premium" ? "Open Generator" : "Start Free Today"}{" "}
          <ArrowRight size={18} />
          </button>

        <p style={{ fontSize: 13, color: "rgba(255,255,255,0.3)", marginTop: 12 }}>
          Free for everyday · Premium packs for high-stakes
        </p>
      </section>


      {/* Features */}
      <section style={S.features}>
        <h2 style={S.sectionTitle}>Everything you need</h2>
        <p style={S.sectionSubtitle}>Marketing all done for you</p>
        <div style={S.featureGrid}>
          {features.map((f, i) => (
            <div key={i} className="feature-card" style={{ ...S.featureCard, transition: "all 0.2s" }}>
              <div style={S.featureIcon}>{f.icon}</div>
              <h3 style={S.featureTitle}>{f.title}</h3>
              <p style={S.featureText}>{f.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={S.ctaSection}>
        <h2 style={S.ctaTitle}>Generated Content?</h2>
        <p style={S.ctaSubtitle}>
          Get your Marketing Done!!!!
        </p>
        <button
          className="cta-btn"
          onClick={() =>
            navigate(user?.role === "premium" ? "/dashboard" : "/auth")
          }
          style={{ ...S.ctaBtn, animation: "fadeUp 0.8s ease both" }}
          >
          {user?.role === "premium" ? "Open Generator" : "Start Free Today"}{" "}
          <ArrowRight size={18} />
          </button>

      </section>

      {/* Footer */}
      <footer style={S.footer}>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 700, color: "#2a2a35", marginBottom: 8 }}>⚡ Content</div>
        <p style={{ fontSize: 13, color: "#252525" }}>Market Now</p>
         <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 700, color: "#2a2a35", marginBottom: 8 }}>⚡ Content</div>
        <p style={{ fontSize: 13, color: "#252525" }}>Market Now.</p>
        <div style={{ marginTop: 12, display: "flex", gap: 16, justifyContent: "center" }}>
          <a href="/privacy" style={{ fontSize: 12, color: "#333", textDecoration: "none" }}>Privacy Policy</a>
          <a href="/terms" style={{ fontSize: 12, color: "#333", textDecoration: "none" }}>Terms of Service</a>
        </div>
      </footer>
    </div>
  );
}

const S = {
  page: {
    width: "1900px",
    minHeight: "100vh",
    background: "#0C0C0E",
    color: "#E8E8EC",
    fontFamily: "'DM Sans', sans-serif",
    position: "relative",
    overflow: "hidden",
    paddingTop: 50,
  },
  glow1: {
    position: "fixed",
    top: -100, right: -100,
    width: 500, height: 500,
    background: "rgba(124,58,237,0.15)",
    borderRadius: "50%",
    filter: "blur(120px)",
    pointerEvents: "none",
  },
  glow2: {
    position: "fixed",
    bottom: -100, left: -100,
    width: 500, height: 500,
    background: "rgba(74,222,128,0.08)",
    borderRadius: "50%",
    filter: "blur(120px)",
    pointerEvents: "none",
  },
  header: {
    borderBottom: "1px solid #1E1E28",
    padding: "0 24px",
    top: 0,
    marginTop: "1000px",
    background: "rgba(12,12,14,0.96)",
    backdropFilter: "blur(16px)",
    zIndex: 100,
  },
  headerInner: {
    maxWidth: 960,
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 60,
  },
  logoText: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 22,
    fontWeight: 700,
    color: "#E8E8EC",
  },
  logoBeta: {
    fontSize: 10,
    fontWeight: 600,
    color: "#C8A96E",
    border: "1px solid #C8A96E",
    borderRadius: 4,
    padding: "2px 6px",
    letterSpacing: "0.08em",
  },
  navBtn: {
    background: "#C8A96E",
    border: "none",
    color: "#0C0C0E",
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 600,
    padding: "8px 16px",
    borderRadius: 8,
    fontFamily: "'DM Sans', sans-serif",
  },
  signOutBtn: {
    background: "none",
    border: "1px solid #2a2a35",
    color: "#666",
    cursor: "pointer",
    fontSize: 13,
    padding: "8px 14px",
    borderRadius: 8,
    fontFamily: "'DM Sans', sans-serif",
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  hero: {
    maxWidth: 700,
    margin: "0 auto",
    padding: "100px 24px 60px",
    textAlign: "center",
    position: "relative",
    zIndex: 1,
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12,
    color: "#C8A96E",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    marginBottom: 24,
  },
  heroTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: "clamp(42px, 7vw, 70px)",
    fontWeight: 900,
    lineHeight: 1.05,
    color: "#F0F0F5",
    marginBottom: 20,
  },
  heroSubtitle: {
    fontSize: 17,
    color: "#777",
    lineHeight: 1.75,
    marginBottom: 32,
  },
  tag: {
    fontSize: 12,
    color: "#444",
    border: "1px solid #1E1E28",
    borderRadius: 20,
    padding: "5px 12px",
  },
  ctaBtn: {
    background: "linear-gradient(90deg, #7c3aed, #4ade80)",
    color: "#fff",
    border: "none",
    borderRadius: 12,
    padding: "16px 40px",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "'DM Sans', sans-serif",
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    transition: "all 0.2s",
  },
  stats: {
    display: "flex",
    justifyContent: "center",
    gap: 48,
    flexWrap: "wrap",
    padding: "40px 24px",
    borderTop: "1px solid #1E1E28",
    borderBottom: "1px solid #1E1E28",
    position: "relative",
    zIndex: 1,
  },
  stat: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
  },
  statNum: {
    fontSize: 28,
    fontWeight: 800,
    color: "#F0F0F5",
    fontFamily: "'Playfair Display', serif",
  },
  statLabel: {
    fontSize: 11,
    color: "#444",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
  },
  features: {
    maxWidth: 900,
    margin: "0 auto",
    padding: "80px 24px",
    textAlign: "center",
    position: "relative",
    zIndex: 1,
  },
  sectionTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 36,
    fontWeight: 700,
    color: "#F0F0F5",
    marginBottom: 12,
  },
  sectionSubtitle: {
    fontSize: 16,
    color: "#555",
    marginBottom: 48,
  },
  featureGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 24,
  },
  featureCard: {
    background: "#13131A",
    border: "1px solid #1E1E28",
    borderRadius: 16,
    padding: "32px 24px",
    textAlign: "left",
  },
  featureIcon: {
    width: 48,
    height: 48,
    borderRadius: 12,
    background: "linear-gradient(135deg, #7c3aed, #4ade80)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 20,
  },
  featureTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 20,
    fontWeight: 700,
    color: "#F0F0F5",
    marginBottom: 8,
  },
  featureText: {
    fontSize: 14,
    color: "#666",
    lineHeight: 1.7,
  },
  ctaSection: {
    textAlign: "center",
    padding: "80px 24px",
    borderTop: "1px solid #1E1E28",
    position: "relative",
    zIndex: 1,
  },
  ctaTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 36,
    fontWeight: 900,
    color: "#F0F0F5",
    marginBottom: 16,
  },
  ctaSubtitle: {
    fontSize: 16,
    color: "#555",
    marginBottom: 32,
    maxWidth: 500,
    margin: "0 auto 32px",
  },
  footer: {
    borderTop: "1px solid #1E1E28",
    padding: "40px 24px",
    textAlign: "center",
  },
};
